import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  standalone: true,
  name: 'percentage'
})
export class PercentagePipe implements PipeTransform {

  transform(value: number | null | undefined, decimalPlaces: number = 2): string {
    if (value === null || value === undefined) {
      return 'N/A';
    }
    const formatted = value.toFixed(decimalPlaces);
    return parseFloat(formatted) === 0 ? `~${formatted}%` : `${formatted}%`;
  }
}
